import React from "react"
import { ReactComponent as CloseIcon } from './CloseIcon.svg';
import styles from './InputError.module.scss';

interface InputErrorProps {
  text?: string;
}
export const InputError: React.FC<InputErrorProps> = (props) => {
  const { text } = props;

  if (!text) {
    return null;
  }

  return (
    <div className={styles.InputError}>
      <div className={styles.containerIcon}>
        <CloseIcon />
      </div>
      <div className={styles.containerText}>
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  )
}